import { render, staticRenderFns } from "./ShopingList.vue?vue&type=template&id=59955c72&scoped=true"
import script from "./ShopingList.vue?vue&type=script&lang=js"
export * from "./ShopingList.vue?vue&type=script&lang=js"
import style0 from "./ShopingList.vue?vue&type=style&index=0&id=59955c72&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59955c72",
  null
  
)

export default component.exports